// extracted by mini-css-extract-plugin
export var accordion = "_d6-0";
export var chevron = "_d6-3";
export var closed = "_d6-2";
export var content = "_d6-4";
export var open = "_d6-1";
export var rotate = "_d6-5";